import React from 'react';

import { findTokenVerifiedListItem, isNetworkIconLogo } from 'lib/token/tokenVerifiedList';

import useUsd1SwapPoolToken from './useUsd1SwapPoolToken';

export type TokenVerifiedDisplay = {
  logoUrl: string | null;
  isNetworkIcon: boolean;
  tooltip: string;
};

export default function useTokenVerifiedDisplay(tokenAddress: string | undefined) {
  const whitelistItem = React.useMemo(() => (
    tokenAddress ? findTokenVerifiedListItem(tokenAddress) : null
  ), [ tokenAddress ]);

  const { poolToken, isPoolsLoading } = useUsd1SwapPoolToken(whitelistItem ? undefined : tokenAddress);

  const display = React.useMemo((): TokenVerifiedDisplay | null => {
    if (whitelistItem) {
      return {
        logoUrl: whitelistItem.logoUrl,
        isNetworkIcon: isNetworkIconLogo(whitelistItem.logoUrl),
        tooltip: `Verified ${ whitelistItem.symbol } token`,
      };
    }

    if (poolToken) {
      return {
        logoUrl: poolToken.rewardTokenLogoURL,
        isNetworkIcon: false,
        tooltip: 'Listed on USD1 Swap Farm',
      };
    }

    return null;
  }, [ poolToken, whitelistItem ]);

  return {
    display,
    isLoading: !whitelistItem && isPoolsLoading,
  };
}
